module.exports = __webpack_public_path__ + "static/media/photo_015.99f70795.JPG";